import type { FC, ReactNode } from 'react'

import { Signal, SignalHigh, SignalLow, SignalMedium } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LevelBadgeProps {
    courseId: string
    level: string
    className?: string
}

const LEVEL_STYLES: Record<string, { className: string, icon: typeof Signal }> = {
    beginner: { className: 'bg-accent text-accent-foreground', icon: SignalLow },
    intermediate: { className: 'bg-secondary text-secondary-foreground', icon: SignalMedium },
    advanced: { className: 'bg-foreground text-background', icon: SignalHigh }
}

const FALLBACK_STYLE = { className: 'bg-muted text-muted-foreground', icon: Signal }

export const LevelBadge: FC<LevelBadgeProps> = ({ courseId, level, className }): ReactNode => {
    const style = LEVEL_STYLES[level.trim().toLowerCase()] ?? FALLBACK_STYLE
    const Icon = style.icon

    return (
        <span className={cn('inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium', style.className, className)}>
            <Icon className='size-3.5' aria-hidden='true' />
            <span data-mdlfy-cms={`courses:${courseId}:level`}>{level}</span>
        </span>
    )
}
